import { render, staticRenderFns } from "./PathCreateJourney.vue?vue&type=template&id=7033f792"
import script from "./PathCreateJourney.vue?vue&type=script&lang=js"
export * from "./PathCreateJourney.vue?vue&type=script&lang=js"
import style0 from "./PathCreateJourney.vue?vue&type=style&index=0&id=7033f792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports